export default "__VITE_ASSET__DguvYRc8__"